// extracted by mini-css-extract-plugin
module.exports = {"dek":"dek___3UjB8"};